/**
 * Убирает слэш в конце пути
 * @kind helper
 * @param path путь
 * @returns string
 * @example removeTrailingSlash('/stores/') // '/stores'
 */
export const removeTrailingSlash = (path: string) => path.replace(/\/$/, '');
